import React, { useState } from 'react';
import {
  Box,
  Container,
  Stack,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import CheckIcon from '@mui/icons-material/Check';
import { Link } from 'react-router-dom';
import { useLanguage, Language } from '../context/LanguageContext';

// Fetch government name from .env
const gpTitle = 'ग्रामपंचायत पारगाव ';
const gpSubtitle = 'तालुका पनवेल , जिल्हा रायगड ';

const Header = () => {
  const { language, setLanguage } = useLanguage();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleLanguageClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLanguageClose = (lang?: Language) => {
    if (lang) {
      setLanguage(lang);
    }
    setAnchorEl(null);
  };

  const languages = [
    { code: 'mr' as Language, label: 'मराठी' },
    { code: 'hi' as Language, label: 'हिंदी' },
    { code: 'en' as Language, label: 'English' },
  ];

  return (
    <Box 
      component="header" 
      sx={{
        background: '#00106e',
        color: 'white',
        py: 2,
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={2}
        >
          {/* Logo and Title Section - Centered */}
          <Stack 
            direction="row" 
            alignItems="center" 
            spacing={2}
            component={Link}
            to="/"
            sx={{ textDecoration: 'none', color: 'inherit', flexGrow: 1, justifyContent: "center" }}
          >
            <Box
              component="img"
              src="/pargaonlogo.jpg"
              alt="Grampanchayat Logo"
              sx={{
                width: { xs: 80, md: 80 },
                height: { xs: 70, md: 70 },
                
              }}
            />
            <Stack alignItems="center">
              <Typography 
                variant="h4" 
                component="h1"
                sx={{
                  fontSize: { xs: '1.8rem', md: '2.2rem' },
                  fontWeight: 600,
                  lineHeight: 1.2,
                  textAlign: "center",
                }}
              >
                {gpTitle}
              </Typography>
              <Typography 
                variant="body1"
                sx={{
                  fontSize: { xs: '1rem', md: '1.2rem' },
                  opacity: 0.9,
                  pl: 2,  // Indentation for तालुका पनवेल, जिल्हा रायगड
                  textAlign: "center",
                }}
              >
                {gpSubtitle}
              </Typography>
            </Stack>
          </Stack>

          {/* Right Side Controls - Aligned to End */}
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            sx={{
              '& .MuiIconButton-root': {
                color: 'white',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                },
              },
            }}
          >
            {/* Weather Widget
            <Stack direction="row" alignItems="center" spacing={1}>
              <WbSunnyIcon />
              <Typography variant="body2">32°C वडघर</Typography>
            </Stack> */}

            {/* Language Toggle */}
            {/* <IconButton 
              aria-label="change language"
              onClick={handleLanguageClick}
              sx={{ 
                border: '1px solid rgba(255, 255, 255, 0.3)',
                '&:hover': {
                  border: '1px solid rgba(255, 255, 255, 0.5)',
                },
              }}
            >
              <TranslateIcon />
            </IconButton> */}
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => handleLanguageClose()}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                },
              }}
            >
              {languages.map((lang) => (
                <MenuItem
                  key={lang.code}
                  onClick={() => handleLanguageClose(lang.code)}
                  selected={language === lang.code}
                >
                  <ListItemIcon>
                    {language === lang.code && <CheckIcon fontSize="small" />}
                  </ListItemIcon>
                  <ListItemText>{lang.label}</ListItemText>
                </MenuItem>
              ))}
            </Menu>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Header;
